// extracted by mini-css-extract-plugin
export default {"dueDateOuter":"styles-module__orhGB"};